import { useQuery } from '@apollo/client';
import { Alert, Container, Divider, Group, Loader, Stack, Table, Text } from '@mantine/core';
import { activeProductsStock } from '../graphql/query';

export const StockPage = () => {
  const { data, loading } = useQuery(activeProductsStock);

  if (loading)
    return (
      <Container my="md" fluid>
        <Alert color="blue" icon={<Loader size={16} />}>
          Načítavam produkty...
        </Alert>
      </Container>
    );

  if (!data || data.activeProductsStock.length === 0)
    return (
      <Container my="md" fluid>
        <Alert color="orange">Momentálne neponúkame žiadne produkty!</Alert>
      </Container>
    );

  return (
    <Container my="md" fluid>
      {data.activeProductsStock
        .slice()
        .sort((a, b) => +b.code - +a.code)
        .map((product) => (
          <Stack gap="xs" key={product.id}>
            <Divider />
            <Group justify="space-between">
              <Text fz={48} fw={700}>
                Kód {product.code} - {product.price} €
              </Text>
              <Text fz={48} fw={700}>
                {product.name}
              </Text>
            </Group>
            <Table withTableBorder withColumnBorders withRowBorders fz={36} fw={700}>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Variant</Table.Th>
                  <Table.Th>Skladom</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {product.variants?.map((variant) => (
                  <Table.Tr key={variant.id}>
                    <Table.Td
                      c={variant.stock === 0 ? 'red' : variant.stock <= 3 ? 'orange' : 'teal'}
                    >
                      {variant.attributes?.map((attr) => attr.value).join(' ')}
                    </Table.Td>
                    <Table.Td
                      c={variant.stock === 0 ? 'red' : variant.stock <= 3 ? 'orange' : 'teal'}
                    >
                      {variant.stock > 3 ? 'dosť' : variant.stock} ks
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Stack>
        ))}
    </Container>
  );
};
